var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "d-flex justify-center align-center",
      staticStyle: {
        "min-height": "300px"
      }
    },
    [
      _c("v-progress-circular", {
        attrs: {
          indeterminate: "",
          color: "primary",
          size: "62"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }